



























import { Component, Vue, Watch } from 'vue-property-decorator';

import SearchService from '@/api/SearchService';

import { ISearchResponse } from '@/models/general';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import SearchBarItem from '@/componentsV2/organisms/SearchBar/SearchBarItem.vue';
import PaginationSelector from '@/componentsV2/molecules/PaginationSelector/PaginationSelector.vue';
import SearchBarEmptyState from '@/componentsV2/organisms/SearchBar/SearchBarEmptyState.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';

@Component({
  components: {
    Typography,
    SearchBarItem,
    PaginationSelector,
    SearchBarEmptyState,
    Page
  }
})
export default class SearchResult extends Vue {
  searchService: SearchService = new SearchService();

  options: ISearchResponse[] = [];
  loading = false;
  totalItems = 0;

  get tPrefix() {
    return 'common.components.searchResult';
  }

  get textSearched(): string {
    return (this.$route.query.text || '') as string;
  }

  get page(): number {
    const numberOfPages = Math.ceil(this.totalItems / 3);
    let page = (Number(this.$route.query.page) || 1) as number;

    if (page > numberOfPages || page <= 0) page = 1;

    return page;
  }

  back() {
    this.$router.back();
  }

  handleClick(option: ISearchResponse) {
    this.$router.push(option.path);
  }

  @Watch('$route')
  changedRoute() {
    this.search();
  }

  async search() {
    try {
      this.loading = true;
      this.$showLoaderWithLocker();
      const response = await this.searchService.search(
        this.textSearched,
        this.page * 3 - 3
      );
      this.options = response.data.items;
      this.totalItems = response.data.total;
    } finally {
      this.loading = false;
      this.$hideLoader();
    }
  }

  created() {
    this.search();
  }
}
